// import React from "react";
// import { Box, Heading, Text, Button } from "grommet";
// import { LinkPrevious } from "grommet-icons";
// import { useNavigate } from "react-router-dom";
// export const QuizSummary = ({ numberOfQuestions, onModify, onStart }) => {
//   const navigate = useNavigate();
//   return (
//     <Box fill="vertical" justify="between">
//       <Box flex="grow">
//         <Box
//           margin={{ horizontal: "medium", top: "small" }}
//           direction="row"
//           justify="between"
//           align="begin"
//         >
//           <LinkPrevious
//             size="large"
//             onClick={() => navigate(-1)}
//             color="brand"
//           />
//         </Box>
//         <Box flex direction="column" gap="medium">
//           <Box
//             margin={{ horizontal: "medium", top: "small" }}
//             direction="row"
//             justify="between"
//             align="center"
//           >
//             <Heading level="1" margin="none">
//               Review assessment details
//             </Heading>
//           </Box>

//           {/* <Box
//             border={{ color: "brand", size: "xsmall" }}
//             width="75%"
//             alignSelf="end"
//           /> */}
//           <Box pad="medium" gap="medium" align="center">
//             <Box
//               pad="medium"
//               border={{ color: "brand", size: "small" }}
//               round="small"
//               width="large"
//             >
//               <Text>
//                 <b>Assessment Settings</b>
//               </Text>
//               <Text>Number of Questions: {numberOfQuestions}</Text>
//               <Text>Duration: {numberOfQuestions} minutes</Text>
//             </Box>
//             <Box
//               pad="medium"
//               background="light-2" // Subtle background for emphasis
//               round="small"
//               width="large"
//               border={{ color: "brand", size: "small" }} // Border to highlight this section
//             >
//               <Heading level="3">
//                 Important information before creating team assessments
//               </Heading>
//               <Text>
//                 <b>1. Purpose of the assessment:</b> This assessment is designed
//                 to help your team identify their skill levels and areas for
//                 improvement. It allows you to track their progress and provide
//                 tailored support for their growth.
//               </Text>
//               <Text margin={{ top: "small" }}>
//                 <b>2. Define clear objectives:</b> Ensure that each assessment
//                 aligns with the goals you’ve set for your team. Select questions
//                 that will accurately assess the relevant skills needed for their
//                 roles.
//               </Text>
//               <Text margin={{ top: "small" }}>
//                 <b>3. Set realistic expectations:</b> The assessment is a tool
//                 to guide your team in identifying growth opportunities. Make
//                 sure they understand that this is for their development and not
//                 a performance test.
//               </Text>
//               <Text margin={{ top: "small" }}>
//                 <b>4. Provide constructive feedback:</b> Once the assessments
//                 are completed, use the results to give your team actionable
//                 insights and create personalized development plans.
//               </Text>
//               <Text margin={{ top: "small" }}>
//                 <b>5. Data privacy and confidentiality:</b> All responses will
//                 be kept confidential and used solely to support your team’s
//                 growth. No data will be shared externally.
//               </Text>
//             </Box>

//             <Box
//               direction="row"
//               gap="medium"
//               justify="center"
//               margin={{ top: "medium" }}
//             >
//               <Button label="Go back and modify" onClick={onModify} />
//               <Button
//                 label="Create assessment"
//                 onClick={onStart}
//                 primary
//                 // disabled={!termsAccepted}
//               />
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

import React from "react";
import { Box, Heading, Text, Button } from "grommet";
import { LinkPrevious } from "grommet-icons";
import { useNavigate } from "react-router-dom";
import BreadcrumbNavigation from "./BreadcrumbNavigation2";

export const QuizSummary = ({ numberOfQuestions, onModify, onStart }) => {
  const navigate = useNavigate();

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow" pad="medium">
        {/* Header with back button and title */}
        <Box
          margin={{ bottom: "small" }}
          pad="small"
          direction="row"
          align="center"
          justify="between"
          // background="light-2"
          // round="small"
          // elevation="small"
          height= "50px"
        >
          <Box direction="row" align="center" gap="small">
            <LinkPrevious
              size="large"
              onClick={() => navigate(-1)}
              color="brand"
            />
            <BreadcrumbNavigation 
            current={"Step 4: Review Assessment Details"} 
            previous={"Select Skills"} 
            />
          </Box>
        </Box>

        {/* Divider below the header */}
        {/* <Box
          border={{ color: "brand", size: "xsmall" }}
          width="75%"
          alignSelf="center"
          margin={{ top: "small" }}
        /> */}

        {/* Main Content */}
        <Box pad="medium" gap="medium" align="center">
          {/* Assessment Settings Box */}
          <Box
            pad="medium"
            border={{ color: "brand", size: "small" }}
            round="small"
            width="large"
            background="light-1"
          >
            <Text>
              <b>Assessment Settings</b>
            </Text>
            <Text>Number of Questions: {numberOfQuestions}</Text>
            <Text>Duration: {numberOfQuestions} minutes</Text>
          </Box>

          {/* Important Information Box */}
          <Box
            pad="medium"
            background="light-2"
            round="small"
            width="large"
            border={{ color: "brand", size: "small" }}
          >
            <Heading level="3" margin={{ bottom: "small" }}>
              Important Information Before Creating Assessments
            </Heading>
            <Text>
              <b>1. Purpose of the assessment:</b> This assessment is designed
              to help your team identify their skill levels and areas for
              improvement. It allows you to track their progress and provide
              tailored support for their growth.
            </Text>
            <Text margin={{ top: "small" }}>
              <b>2. Define clear objectives:</b> Ensure that each assessment
              aligns with the goals you’ve set for your team. Select questions
              that will accurately assess the relevant skills needed for their
              roles.
            </Text>
            <Text margin={{ top: "small" }}>
              <b>3. Set realistic expectations:</b> The assessment is a tool to
              guide your team in identifying growth opportunities. Make sure
              they understand that this is for their development and not a
              performance test.
            </Text>
            <Text margin={{ top: "small" }}>
              <b>4. Provide constructive feedback:</b> Once the assessments are
              completed, use the results to give your team actionable insights
              and create personalized development plans.
            </Text>
            <Text margin={{ top: "small" }}>
              <b>5. Data privacy and confidentiality:</b> All responses will be
              kept confidential and used solely to support your team’s growth.
              No data will be shared externally.
            </Text>
          </Box>

          {/* Buttons */}
          <Box
            direction="row"
            gap="medium"
            justify="center"
            margin={{ top: "medium" }}
          >
            <Button label="Go Back and Modify" onClick={onModify} />
            <Button label="Proceed" onClick={onStart} primary />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
